'use client';

import React from 'react';

import PcButton from '@/shared/ui/button/PcButton';
import ImageWithSkeleton from '@/shared/ui/image/ImageWithSkeleton';
import { ArrowIcon } from '@/shared/ui/svgs';

interface PcWideCard {
  title: string;
  content: string;
  imagePath: string;
  onClick?: () => void;
}

const PcWideCard = ({ title, content, imagePath, onClick }: PcWideCard) => {
  return (
    <div
      className={
        'w-[845px] h-[400px] bg-secondary-white rounded-[32px] py-[16px] pl-[16px] pr-[40px] flex items-center cursor-pointer shadow-[0_6px_40px_rgba(0,0,0,0.06)]'
      }
      onClick={() => {
        onClick?.();
      }}
    >
      <div className="w-[503px] h-[368px]">
        <ImageWithSkeleton
          width={503}
          height={368}
          src={imagePath}
          alt={'no Image'}
          fill
          className="rounded-[16px] object-cover"
        />
      </div>
      <div className={'relative w-[246px] h-[304px] ml-[40px]'}>
        <h3 className={'text-locale-28 font-bold line-clamp-2'}>{title}</h3>
        <p className={'text-locale-18 text-[#434343] font-regular mt-[16px] line-clamp-5'}>
          {content}
        </p>
        <PcButton
          shape="circle"
          variant={'outline'}
          size={56}
          className="absolute bottom-[0px] right-[0px]"
        >
          <ArrowIcon color={'black'} />
        </PcButton>
      </div>
    </div>
  );
};

export default PcWideCard;
